export default "/images/80e96e904d7f397bc73a5dbd32b34b9f.jpg";